import { Grid2, Typography, Box, Button } from "@mui/material"
import { memo, useMemo, useState, useCallback } from "react";
import Table from "./Table";
import Spinner from "./Spinner";
import { useSnackbar } from "../utils/index.js";
import useListStyles from "./styles/List";
import {
    deleteButtonCell,
    censusDateHeader,
    aliveAnimalsHeader,
    registeredInFlockHeader,
    populationFemaleAliveHeader,
    populationMaleAliveHeader,
    animalsNeverLambedHeader,
    animalsNotLambedInPeriodHeader,
    animalsLambedInPeriodHeader,
    populationLambsHeader,
    maleAliveLambsHeader,
    maleDeadLambsHeader,
    femaleAliveLambsHeader,
    femaleDeadLambsHeader,
    populationLambedAtLeastOnceHeader,
} from "./TableHeaders.js";
import AreYouSurePopup from "./popups/AreYouSurePopup.js";


const OwnerPopulationTable = ({
    getInventories,
    fetchedInventories,
    setFetchedInventories,
    setStep,
    owner,
    deleteInventory,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedInventory, setSelectedInventory] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const listClasses = useListStyles();
    const { success, error } = useSnackbar();


    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { inventories } = await getInventories(owner?._id);
                setFetchedInventories(inventories);
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )

    const handleInventoryClicked = (value) => {
        console.log("Value clicked", value);
        setSelectedInventory(value);
        setIsPopupOpen(true);
    }

    const handleRecordDelete = async () => {
        setIsLoading(true);
        const { success: scs, message } = await deleteInventory(selectedInventory?._id);
        if (scs) {
            success(message);
            fetchData();
        } else {
            error(message);
        }
        setSelectedInventory(null);
        setIsPopupOpen(false);
        setIsLoading(false);
    };

    const tableColumns = useMemo(() => [
        deleteButtonCell(handleInventoryClicked),
        censusDateHeader(handleInventoryClicked),
        aliveAnimalsHeader,
        registeredInFlockHeader,
        populationFemaleAliveHeader,
        populationMaleAliveHeader,
        animalsNeverLambedHeader,
        populationLambedAtLeastOnceHeader,
        animalsNotLambedInPeriodHeader,
        animalsLambedInPeriodHeader,
        populationLambsHeader,
        maleAliveLambsHeader,
        maleDeadLambsHeader,
        femaleAliveLambsHeader,
        femaleDeadLambsHeader,
    ]);


    return (
        <>
            <Spinner open={isLoading} />
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Διαγραφή Απογραφής"
                titleColor="black"
                onClose={() => setIsPopupOpen(false)}
                innerText={`Είστε σίγουροι ότι θέλετε να διαγράψετε την Απογραφή που έγινε στις ${new Date(selectedInventory?.censusDate).toLocaleDateString("el-GR")};`}
                declineText="Πίσω"
                onDecline={() => setIsPopupOpen(false)}
                acceptText="Ναι, Διαγραφή Απογραφής"
                onAccept={() => handleRecordDelete()}
            />
            <Grid2 container className={listClasses.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                    <Typography variant="h6" className={listClasses.form_title}>
                        {`Λίστα απογραφών της εκτροφής ${owner?.code} - ${owner?.lastName} ${owner?.firstName}`}
                    </Typography>
                </Box>
                <Table
                    data={fetchedInventories}
                    noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν εγγραφές!"}
                    columns={tableColumns}
                />
            </Grid2>
            <Box sx={{ width: "100%", marginTop: 3, marginLeft: 6, marginBottom: 3, display: "flex", justifyContent: "start" }}>
                <Button variant="outlined" color="secondary" onClick={() => setStep(2)}>
                    Πίσω
                </Button>
            </Box>
        </>
    )
}

export default memo(OwnerPopulationTable);